const RUSSIA_ENTITY_ID = '29475334';

const shouldShowRussiaBanner = (countryId?: string) =>
  countryId === RUSSIA_ENTITY_ID;

export { shouldShowRussiaBanner };
